import styled from 'styled-components';
import { rem } from 'polished';
import Login from '../../Login';

const StyledLogin = styled(Login)`
  background-image: none;
  background-color: rgba(0, 0, 0, 0.65);

  .login-wrapper {
    background-color: transparent;
  }
  .login-razorWidget {
    margin-bottom: ${rem('10px')};
  }
  .login-text {
    margin-top: 0;
    margin-bottom: ${rem('22px')};
    font-family: ${props => props.theme.fonts.medium};
    font-size: ${rem('14px')};
    color: ${props => props.theme.colors.light};
  }
  .login-enter {
    font-size: ${rem('12px')};
  }
  .login-enter--password {
    color: ${props => props.theme.colors.light};
  }
`;

export { StyledLogin };
